<template>
    <div class="fillcontain">
        <el-header style="font-size: 30px">{{this.vipCardTitle}}</el-header>
        <div class="table_container">
            <el-table
                :data="tableData"
                style="width: 100%"
                v-loading="loading">
              <el-table-column
                label="时间"
                prop="createTime">
              </el-table-column>
              <el-table-column
                label="金额"
                :formatter="valueFormat">
              </el-table-column>
              <el-table-column
                label="余额"
                :formatter="afterValueFormat">
              </el-table-column>
              <el-table-column
                label="事项"
                prop="note">
              </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pages.page"
                  :page-size="pages.pageSize"
                  layout="total, prev, pager, next"
                  :total="pages.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                loading:false,
                call_tag:{
                    id:0,
                    content:"",
                    status:""+1,
                },
                pages:{
                    offset: 0,
                    pageSize: 10,
                    page: 1,
                    total: 0,
                },
              tableData: [],
              vipCardID:0,
              vipCardType:"",
              vipCardTitle:"",
            }
        },
        created(){
            this.vipCardID = this.$route.query.user_card_id;
            this.vipCardType = this.$route.query.type;
            if(this.vipCardType == 'balance'){
                this.vipCardTitle= "余额记录";
            }else if(this.vipCardTitle == 'point'){
                this.vipCardTitle= "积分记录";
            }else if(this.vipCardType == 'grade'){
                this.vipCardTitle= "等级记录";
            }
            this.initData();
        },
        methods: {
            initData(){
              this.loading = true;
              var that = this;
              that.$api.get('/store/vip_card/logs/'+this.vipCardID+"?type="+this.vipCardType, that.pages, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.tableData = res.data.userCardLogs.content;
                    that.pages.total = res.data.userCardLogs.totalElements;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },

            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.pages.page = val;
                this.pages.offset = (val - 1)*this.pages.pageSize;
                this.initData()
            },
            valueFormat(row,column){
              return row.type == 'balance'?row.doValue/100:row.doValue;
            },
            afterValueFormat(row,column){
                return row.type == 'balance'?row.afterValue/100:row.afterValue;
            },

        },
    }
</script>

<style lang="less">
	@import '../../../style/mixin';
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .table_container{
        padding: 20px;
        text-align: left;
    }
    .Pagination{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/store/components/UserCardLogs.vue